import { useTranslation } from 'next-i18next';

import { CollectionName } from '@/shared/lib/sj-orm/constants';
import { PersonalIdentifierType } from '@/shared/lib/sj-orm/models/document/personal-identifier.document.dto';

import { InterwillDocumentFormType } from './PersonaldForm/types';
import { InterwillCreateModalEntityType } from './types';

const TITLE_BY_ENTITY_TYPE = {
  [CollectionName.ASSETS]: 'asset.title',
  [CollectionName.PERSONAL_IDENTIFIERS_DOCUMENTS]: 'document.title',
};

const TITLE_BY_DOCUMENT_TYPE = {
  [PersonalIdentifierType.PASSPORT]: 'passport.title',
  [PersonalIdentifierType.NATIONAL_ID]: 'nationalId.title',
};

type InterwillAddModalTitleProps = {
  entityType: InterwillCreateModalEntityType;
  documentFormType: InterwillDocumentFormType | null;
};
export const useTitle = ({ entityType, documentFormType }: InterwillAddModalTitleProps) => {
  const { t } = useTranslation('widgets/modals', { keyPrefix: 'addEntity' });

  return entityType === CollectionName.PERSONAL_IDENTIFIERS_DOCUMENTS && documentFormType
    ? t(TITLE_BY_DOCUMENT_TYPE[documentFormType])
    : t(TITLE_BY_ENTITY_TYPE[entityType]);
};
